import type { PaymentState } from '@fitting-room/contracts'
import { PAYMENT_STATE_LABEL } from '../../../lib/payments'

/**
 * Where an order stands against what it comes to, after tperent's
 * `PaymentBadge`: the same badge on the order list, the order's totals and
 * the payments card, so the same fact always looks the same. Colored from
 * the attribute, so the color can never say something the word does not.
 *
 * Nothing at all for an order that comes to nothing and has nothing paid —
 * one with no lines yet. Arithmetic calls that "paid", and "Paid in full" on
 * an empty order reads as a sale that never happened.
 */
export function PaymentStateBadge({
  state,
  totalMinor,
  paidMinor,
}: {
  readonly state: PaymentState
  readonly totalMinor: number
  readonly paidMinor: number
}) {
  if (totalMinor === 0 && paidMinor === 0) return null
  return (
    <span className="st-badge st-payment-state" data-state={state}>
      {PAYMENT_STATE_LABEL[state]}
    </span>
  )
}
